/** A special meal occupies one child/date/mealtime slot, including ordinary meals. */
export function conflictsWithSpecialDietSelection(
  next: {
    key: string
    studentUserId: string
    date: string
    mealtime: string
    specialDietAccommodationId?: string | null
  },
  current: {
    key: string
    studentUserId: string
    date: string
    mealtime: string
    specialDietAccommodationId?: string | null
  },
): boolean {
  return (
    current.key !== next.key &&
    current.studentUserId === next.studentUserId &&
    current.date === next.date &&
    current.mealtime === next.mealtime &&
    Boolean(next.specialDietAccommodationId || current.specialDietAccommodationId)
  )
}
